import { createContext, useContext } from "react";

/**
 * Lightweight context that passes the current ItemType name
 * from DynamicForm down to DynamicFormField without prop-drilling.
 */
const FormItemTypeContext = createContext<string>("");

export const FormItemTypeProvider = FormItemTypeContext.Provider;
export const useFormItemType = () => useContext(FormItemTypeContext);
